import { Link } from 'react-router-dom';
import { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  const statusColor = comic.status === '连载中' ? 'bg-accent-500' : 'bg-secondary-500';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 星球漫画科幻漫画`}
          title={`${comic.title} - 星球漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`text-[10px] text-background-50 px-2 py-0.5 rounded-full whitespace-nowrap ${statusColor}`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-amber-400 text-xs"></i>
            </div>
            <span className="text-xs text-background-50 font-medium">{comic.rating}</span>
          </div>
        </div>
      </div>
      <h3 className="font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>
      <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-400">
        <span className="flex items-center gap-1">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-eye-line"></i>
          </div>
          {comic.views > 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}
        </span>
        <span className="flex items-center gap-1">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-heart-line"></i>
          </div>
          {comic.favorites > 10000 ? `${(comic.favorites / 10000).toFixed(1)}万` : comic.favorites}
        </span>
      </div>
    </Link>
  );
}